import { Component } from 'preact';
import { Link } from 'preact-router/match';
import styled from 'styled-components';

class SuperNav extends Component {

	scrollToId = (id) => {
		let element = document.getElementById(id);
		element.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		});
	}
	
	constructor(props) {
		super(props);
		this.state = {
			language: null
		};
	}
	

	render() {

		const SuperNavContainer = styled.div`
			align-items: center;
			background-color: ${this.context.colors.primary};
			display: flex;
			height: 10rem;
			margin: 0 auto;
			width: 100%;
			.logo {
				//background-color: ${this.context.colors.accent};
				height: 100%;
				max-width: 10rem; 
				padding: 2rem;
				width: 100%;
				@media only screen and (max-width: 680px) {
					margin: 0 auto;
				}
			}
			.links-wrapper {
				margin-left: auto;
				margin-right: 5rem;
				@media only screen and (max-width: 680px) {
					display: none;
				}
				a {
					color: ${this.context.colors.link};
					cursor: pointer;
					font-family: ${this.context.branding.headerFont};
					letter-spacing: 0.2rem;
					text-decoration: none;
					text-transform: uppercase;
					&:hover {
						color: ${this.context.colors.hoverLink};
					}
					&:not(:last-of-type) {
						margin-right: 4rem;
						@media only screen and (max-width: 680px) {
							margin-right: 3rem;
						}
					}
				}
			}
		`;

		return (
			<SuperNavContainer>
				<img className="logo" src={this.context.branding.logoSmall} alt={this.context.copy.longName} />
				<div className="links-wrapper">
					<a activeClassName="active" onClick={()=>this.scrollToId('careers')}>Careers</a>
					<a activeClassName="active" onClick={()=>this.scrollToId('studio')}>Our Studio</a>
					<a activeClassName="active" href="mailto:evilmojogames@hirezstudios.com">Contact</a>
				</div>
			</SuperNavContainer>
		);
	}
}

export default SuperNav;


// WEBPACK FOOTER //
// ./components/SuperNav.js